import SopList from './SopList';
export default SopList;
